export default __webpack_public_path__ + "static/media/youtube.183c7d58.svg";